const NotAuthHome = () => {
    return(
        <div>
            <h1>Not Auth</h1>
        </div>
    )
}


export default NotAuthHome